<template>

<j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div>
      <a-col :span="24">
        <el-amap-search-box
          ref="mapInt"
          class="search-box"
          :search-option="searchOption" 
          :on-search-result="onSearchResult"
        ></el-amap-search-box>

        <el-amap 
          ref="map"
          vid="amapDemo"
          :amap-manager="amapManager"
          v-if="visible"
          :center="center"
          :zoom="zoom"
          :plugin="plugin"
          :events="events"
          
          style="height:600px;width:100%;"
          class="amap-demo">
            <el-amap-marker :draggable="true" :position="center"></el-amap-marker>
        </el-amap>
      </a-col>
      
    </div>
  </j-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import AMap from 'vue-amap'
  import AMapJS from 'amap-js'

  let amapManager = new AMap.AMapManager();
  let Geocoder;

  export default {
    name: 'map',
    props: {
      centerArr:{
        type:Array,
        default: () => [106.673217,33.153636]
      },
      mapZoom:{
        type:Number,
        default:10
      },
    },
    components: {
      JFormContainer,
      AMapJS
    },
    data () {
      let self = this;
      return {
        title: '地图坐标',
        visible: false,
        confirmLoading: false,
        width:800,
        
        amapManager,
        zoom:this.mapZoom,
        input:"",
        markers:[],
        searchOption:{
          city:"全国",
          citylimit:false
        },
        center:this.centerArr,
        centerAr:this.centerArr,
        events:{
          init:(o)=>{
            o.setMapStyle('amap://styles/edbc379c8110f081c564f98d8c59f80c');//自定义的高德地图的样式
            o.getCity((result)=>{
              
            })
          },
          moveend:()=>{},
          zoomchange:()=>{},
          click:(e)=>{
            self.center = [e.lnglat.lng,e.lnglat.lat];
            
            Geocoder.getAddress(self.center,function(status,result){
              if(status==="complete" && result.info==="OK"){
                self.input = result.regeocode.formattedAddress;
                self.$refs.mapInt.keyword = self.input;
                self.address = self.input;
              }
            })
          }
        },
        plugin: [
          {
            pName:"Geocoder",
            events:{
              init(o){
                Geocoder = o;
                self.center = self.centerAr;
                o.getAddress(self.centerAr,function(status,result){
                  if(status==="complete" && result.info==="OK"){
                    self.input = result.regeocode.formattedAddress;
                    if(self.address!=""){
                      self.$refs.mapInt.keyword = self.address;
                    }else{
                      self.address = self.input;
                      self.$refs.mapInt.keyword = self.input;
                    }
                    
                  }
                })
              }
            }
          },
          {
            showMarker:true,
            pName:"Geolocation",
            events:{
              init(o){
                o.getCurrentPosition((statis,result)=>{
                  if(result && result.position){
                    let lng = result.position.lng;
                    let lat = result.position.lat;
                    self.center = [lng,lat];
                    self.loaded = true;
                    self.$nextTick();
                  }
                })
              }
            }
          }
        ],
        mapEvents: {
          init (o) {
            o.setMapStyle('amap://styles/edbc379c8110f081c564f98d8c59f80c');//自定义的高德地图的样式

          }
        },
        componentMarker: {},
        address:"",
        
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.$nextTick(() => {

      // this.aMapJSAPILoader = new AMapJS.AMapLoader({
      //     key: '98c4ab414f02d3f50f379a25f0f5748d',
      //     version: '2.0',
          
      //   });

      //   this.aMapUILoader = new AMapJS.AMapUILoader({
      //     v: "1.0" // UI组件库版本号
      //   });

      //   this.componentMarker= {
      //     position: this.centerArr,
      //     markerEvents:{
      //       dragend: (e) => {
      //         let lnglat = e.lnglat;
      //         this.componentMarker.position = [lnglat.lng, lnglat.lat];
              
      //         this.Geocoder.getAddress([lnglat.lng, lnglat.lat],function(status, result){
      //           if(status ==="complete"&& result.info ==="OK"){
      //             this.input = result.regeocode.formattedAddress;
      //             this.$refs.mapInt.keyword = this.input;
      //           }
      //         })
      //       }
      //     }
      //   }
      })
    },
    mounted(){
      
    },
    methods: {
      csh(address,centerArr,mapZoom){
        this.$nextTick(() => {
          this.centerAr = centerArr;
          // this.address = address;
          this.showModal();
          // this.$refs.mapInt.keyword = address;
        })
      },
      showModal() {
        this.visible = true;
      },
      handleOk(e) {
        this.confirmLoading = true;
        
        let mapObj = {
          address:this.address,
          zb:this.center
        }
        this.$emit('ok',mapObj);

        this.visible = false;
        this.confirmLoading = false;
        
      },
      handleCancel(e) {
        console.log('Clicked cancel button');
        this.visible = false;
      },
      onSearchResult(pois) {
        //这边类似模糊查询 会返回一个数组，我就直接取第一个值了。
        if(pois.length>=0){
          this.$nextTick(()=>{
            this.$refs.mapInt.keyword = pois[0].name;
          })
        }
        this.address = pois[0].name;
        this.center = [pois[0].lng, pois[0].lat];
        this.componentMarker.position = [pois[0].lng, pois[0].lat];
      },
    },
  }
</script>
<style scoped>
.amap-page-container {
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
}
</style>
<style>
.el-vue-search-box-container {
  margin-top: 10px;
  position: absolute !important;
  width: 80% !important;
  margin-left: 10% !important;
}

</style>